<template>
  <ValidationObserver ref="proxy">
    <!-- <validatable-text-input
        v-model="proxy.number"
        v-test="{ input: 'number' }"
        rules="required"
        :label="$t('Номер')"
        prepend-icon="mdi-numeric" /> -->
    <validatable-text-input
        v-model="proxy.contactPerson"
        v-test="{ input: 'contactPerson' }"
        rules="required"
        :label="$t('ФИО доверенного лица')"
        prepend-icon="person" />
    <validatable-date-picker
        v-model="proxy.dateBegin"
        v-test="{ date: 'dateBegin' }"
        rules="required"
        :label="$t('Дата начала действия')" />
    <validatable-date-picker
        v-model="proxy.dateEnd"
        v-test="{ date: 'dateEnd' }"
        rules="required"
        :label="$t('Дата завершения действия')" />
  </ValidationObserver>

</template>

<script>
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import ValidatableDatePicker from '@/components/reused/ui/ValidatableDatePicker.vue'

  export default {
    components: {
      ValidatableTextInput,
      ValidatableDatePicker
    },
    props: {
      proxyInfo: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        proxy: {
          dateBegin: null,
          dateEnd: null,
          contactPerson: null
          // number: null
        }
      }
    },
    watch: {
      proxyInfo: {
        immediate: true,
        deep: true,
        handler (newVal) {
          if (newVal?.dateBegin) {
            this.proxy.dateBegin = newVal.dateBegin
            this.proxy.dateEnd = newVal.dateEnd
            this.proxy.contactPerson = newVal.contactPerson
            // this.proxy.number = newVal.number
          }
        }
      }
    },
    methods: {
      getData: async function () {
        return {
          ...this.proxy
        }
      }
    }
  }
</script>
